import { render } from "./PaginatorControls.vue?vue&type=template&id=82964cd2&ts=true"
import script from "./PaginatorControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginatorControls.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/core/report/components/PaginatorControls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82964cd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82964cd2', __exports__)) {
    console.log('reload')
    api.reload('82964cd2', __exports__)
  }
  
  module.hot.accept("./PaginatorControls.vue?vue&type=template&id=82964cd2&ts=true", () => {
    console.log('re-render')
    api.rerender('82964cd2', render)
  })

}


export default __exports__